import { DASHBOARDJOBCOUNT } from "../ENVIRONMENT";

function dashboardjobcount(token) {
  // api for get requiremetInfo details
  const response = fetch(DASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}
export { dashboardjobcount };
